import React from 'react'
import AiHero from '../../Components/Automation/AiHero'
import OurServiceOffer from '../../Components/Automation/OurServiceOffer'
import { ChevronRight } from 'lucide-react'
import Perspectives from '../../Components/Accelerating/Perspectives'
import RelatedServices from '../../Components/Accelerating/RelatedServices'
import AccContact from '../../Components/Accelerating/AccContact'
import Banner from '../../Components/Banner'
import { Helmet } from 'react-helmet-async'
import ContactSection from '../../Components/home/ContactSection'


const relatedService = [
    {
        id: 1,
        title: "AI & Intelligent Automation",
        description: "We use machine learning to take care of repetitive tasks for you and turn your data into simple, useful insights that help you make better decisions and grow your business with confidence.",
        image: "/assets/product/p1.png",
        link: "/ai-intelligent-automation"
    },
    {
        id: 2,
        title: "Cloud & DevOps Engineering",
        description: "Speed up development and scale confidently with our secure, reliable cloud infrastructure services built to support your business growth.",
        image: "/assets/product/p3.png",
        link: "/cloud-dev-ops-engineering"
    },
    {
        id: 3,
        title: "Managed Services & Staff Augmentation",
        description: "Boost your ongoing projects with expert IT talent and reliable managed support, ensuring smooth and uninterrupted day-to-day operations.",
        image: "/assets/product/p4.png",
        link: "/managed-services-staff-augmentation"
    },
    {
        id: 4,
        title: "Enterprise Applications & ERP",
        description: "Modernize your business with simple, scalable custom apps and integrated ERP systems that improve efficiency, simplify work, and support growth.",
        image: "/assets/product/p2.png",
        link: "/enterprise-applications-erp"
    }
];

const data = [
    {
        id: 1,
        category: "INDUSTRY 4.0",
        title: "The Role of Edge Computing in Smart Manufacturing",
        link: "#"
    },
    {
        id: 2,
        category: "AUTOMOTIVE IOT",
        title: "Connected Vehicles: Bridging the Gap Between Hardware and Cloud",
        link: "#"
    },
    {
        id: 3,
        category: "INDUSTRIAL AUTOMATION",
        title: "Optimizing Production Lines with Predictive Maintenance and PLC",
        link: "#"
    },
    {
        id: 4,
        category: "EMBEDDED SECURITY",
        title: "Securing Critical Infrastructure in the Age of IoT",
        link: "#"
    }
];

const service = [
    {
        id: 1,
        title: "Embedded Software Design & Development",
        category: "service",
        desc: "We create reliable, fast software for microcontrollers and processors, built to perform smoothly and consistently even in the most demanding, mission-critical environments.",
        defaultBg: "bg-gradient-to-b from-[#01386A] to-[#1C355E]",
        link: "/embedded-services",
    },
    {
        id: 2,
        title: "Firmware Development",
        category: "service",
        desc: "We build secure and reliable firmware that helps hardware run smoothly, improves stability, and ensures consistent performance in everyday operations.",
        defaultBg: "bg-gradient-to-r from-[#01386A] to-[#4B6CB7]",
        link: "/",
    },
    {
        id: 3,
        title: "Hardware Validation & Testing",
        category: "service",
        desc: "Comprehensive testing services including EMI/EMC, environmental, and functional validation to make sure your products are reliable, compliant, and perform exactly as expected in real-world conditions.",
        defaultBg: "bg-gradient-to-br from-[#01386A] to-[#8E9EAB]",
        link: "/",
    },
    {
        id: 4,
        title: "Industrial Automation (PLC / SCADA / DCS)",
        category: "service",
        desc: "We design and implement smart automated control systems that help industries monitor and manage their processes in real time, improving efficiency, reliability, and overall performance in a simple and practical way.",
        defaultBg: "bg-gradient-to-bl from-[#01386A] to-[#6A85B6]",
        link: "/industrial-automation",
    },
    {
        id: 5,
        title: "MES (Manufacturing Execution Systems)",
        category: "service",
        desc: "Connecting shop floor data with ERP systems to give clear, real-time visibility into how raw materials are turned into finished products.",
        defaultBg: "bg-gradient-to-tr from-[#01386A] to-[#253B5C]",
        link: "/manufacturing-execution-system",
    },
    {
        id: 6,
        title: "Automotive & IoT Solutions",
        category: "service",
        desc: "We build connected automotive and IoT solutions that help businesses work smarter, use data better, and improve everyday efficiency.",
        defaultBg: "bg-gradient-to-t from-[#01386A] to-[#243B55]",
        link: "/",
    },
]

function EmbeddedSystemsIndustrial() {
    return (
        <div>
            <Helmet>
    <title>
        Cloud & DevOps Engineering Services | Cloud Solutions | Mobikode
    </title>

    <meta
        name="description"
        content="Mobikode provides Cloud and DevOps engineering services to build secure, scalable cloud environments, modernize applications, automate CI/CD pipelines, and improve software delivery."
    />

    <meta
        name="keywords"
        content="Cloud Engineering Services, DevOps Engineering Services, Cloud Solutions, AWS Consulting Services, Azure Cloud Services, Google Cloud Solutions, Cloud Migration Services, Cloud Modernization, DevOps Automation, CI/CD Automation, Kubernetes Services, Containerization Services, Cloud Security Services, Cloud Compliance Services, Multi Cloud Solutions"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/capabilities/cloud-engineering"
    />

    <meta
        property="og:title"
        content="Cloud & DevOps Engineering Services | Cloud Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Modernize your technology infrastructure with Mobikode's Cloud and DevOps engineering solutions. From AWS, Azure and GCP to cloud migration, CI/CD, Kubernetes, security and compliance."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/capabilities/cloud-engineering"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/what/c4.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Cloud & DevOps Engineering Services | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode's cloud and DevOps solutions for AWS, Azure, GCP, cloud migration, CI/CD automation, Kubernetes, containerization, cloud security and compliance."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/what/c4.png"
    />
</Helmet>
            <AiHero title="Industrial Engineering" imgData="/assets/what/c5.png" />
            <section className="w-full py-[50px] lg:py-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[20px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row h-auto lg:h-[323px] group">

                        <div className="overflow-hidden w-full lg:max-w-[624px] h-[250px] lg:h-full relative z-10">
                            <img
                                src="/assets/what/item16.png"
                                alt="Embedded Systems"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>

                        <div className="relative z-20 w-full lg:max-w-[656px] bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] 
                            px-[20px] py-[30px] lg:px-[40px] lg:py-[30px] flex flex-col justify-center
                            -mt-6 lg:mt-0 lg:ml-0">
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-[500] font-graphik text-justify">
                                At Mobikode, we help manufacturers bring their operations closer to the future by
                                connecting machines with smart digital systems. From embedded solutions and firmware to SCADA and IIoT, we build technology that works smoothly on the ground. Our focus is simply to make systems more connected, efficient, and easy to manage, so businesses can adapt, grow, and confidently step into the world of Industry 4.0.   </p>

                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>

                        </div>

                    </div>
                </div>
            </section>
            <OurServiceOffer service={service} />
            {/* <section className='overflow-hidden'>
                <div className="max-w-[1440px] lg:pb-[80px] pb-[40px] w-full mx-auto lg:px-[80px] px-[20px]">
                    <h6 className="text-center font-[600] lg:text-[31px] text-[20px] lg:pb-[80px] pb-[40px] lg:leading-[40px] leading-[30px] text-[#01386A]">Spotlight</h6>

                    <div className="flex lg:flex-row flex-col gap-5">

                        <div className="w-full lg:w-[65%] mx-auto relative group">
                            <div className="relative w-full h-[350px] lg:h-auto lg:aspect-auto">
                                <img src="/assets/what/img6.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px]">Developing a Next-Gen ECU for an Electric Vehicle Manufacturer</h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="w-full lg:w-[35%] mx-auto grid gap-[20px]">

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img5.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            Implementing SCADA Automation for a Smart Factory...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="relative h-[300px] lg:h-auto">
                                <img src="/assets/what/img7.png" className="w-full h-full object-cover" alt="" />
                                <div className="absolute top-0 left-0 w-full h-full bg-[#00000033]"></div>
                                <div className="absolute top-0 left-0 p-[20px] lg:p-[40px] w-full h-full flex flex-col justify-between">
                                    <p className="font-[500] font-graphik text-[16px] lg:text-[18px] leading-[24px] text-[#FFFFFF]">CASE STUDY</p>
                                    <div>
                                        <h6 className="font-[500] font-graphik text-[20px] lg:text-[24px] leading-[26px] lg:leading-[30px] text-[#FFFFFF] max-w-[666px] w-full pb-[20px] line-clamp-2">
                                            IoT-Enabled Predictive Maintenance for Heavy Machinery...
                                        </h6>
                                        <div className="flex items-center gap-2 font-graphik font-[500] text-[16px] text-[#FFFFFF]">
                                            <span>Read More</span>
                                            <ChevronRight size={20} />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section> */}
            <section className="w-full pb-[40px] lg:pb-[80px] bg-white overflow-hidden relative">
                <div className="max-w-[1440px] mx-auto px-[15px] lg:px-[80px]">
                    <div className="relative w-full flex flex-col lg:flex-row lg:items-center group lg:h-[507px]">
                        <div className="relative lg:absolute top-0 right-0 w-full lg:max-w-[656px] h-[250px] md:h-[350px] lg:h-full bg-gray-100 overflow-hidden">
                            <img
                                src="/assets/what/img8.png"
                                alt="Mobikode Engineering"
                                className="w-full h-full object-cover mix-blend-multiply transition-transform duration-700 group-hover:scale-105"
                            />
                        </div>
                        <div className="relative z-20 w-[92%] sm:w-[85%] lg:w-full max-w-[719px] mx-auto lg:mx-0 bg-white shadow-[0_10px_40px_rgba(0,0,0,0.1)] px-[20px] py-[30px] lg:px-[60px] lg:py-[80px] -mt-[40px] lg:mt-0">
                            <h3 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] font-sora mb-[15px] lg:mb-[35px] leading-[1.3]">
                                The Mobikode Engineering Advantage
                            </h3>
                            <p className="text-[#49577A] w-full text-[14px] lg:text-[16px] leading-[1.6] font-graphik font-[500] text-justify">
                                At Mobikode, we bring hardware and software together to build practical, end-to-end engineering solutions. Our work spans everything from chip-level firmware to full-scale industrial automation systems. By blending IoT innovation with solid engineering principles, we help you create smarter, safer, and more efficient products that are built to perform reliably in real-world, demanding environments.
                            </p>
                            <div className="absolute bottom-0 left-0 w-full h-[4px] bg-[#01386A]"></div>
                            <div className="absolute bottom-0 left-0 h-[4px] bg-[#ED6800] w-0 transition-all duration-500 ease-out group-hover:w-full"></div>
                        </div>
                    </div>
                </div>
            </section>
            {/* <Perspectives data={data} /> */}
            <RelatedServices relatedService={relatedService} />
            {/* <section className='relative'>
                <img src="/assets/product/bg1.jpg" className='lg:h-[683px] h-[800px] w-full object-cover' alt="" />
                <div className="max-w-[1440px] w-full mx-auto lg:px-[80px] px-[20px] top-1/2 -translate-y-1/2 absolute left-1/2 -translate-x-1/2">
                    <AccContact />
                </div>
            </section> */}
            <Banner title="Industrial Engineering" text=" Empowering businesses with intelligent, autonomous AI solutions that drive efficiency and innovation." />
            <ContactSection/>
        </div>
    )
}

export default EmbeddedSystemsIndustrial